/*
 * Auto table of contents for single posts.
 *
 * Ported from the block theme's chrome.js: builds the rail from every <h2> in
 * the article body, gives each one an id, wires smooth-scroll, and highlights
 * the section currently in view (scrollspy). The rail stays hidden when the
 * article has no headings, so short posts never show an empty box.
 *
 * Plain JS on purpose — no jQuery, so it keeps working if the bundle's jQuery
 * dependency ever goes away.
 */
(function() {
    // The classic header is position:relative, so this is breathing room rather
    // than a fixed-header allowance.
    const SCROLL_OFFSET = 24;
    const SPY_OFFSET = 120;

    function slugify(text, used) {
        const base = (text || 'section')
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-') || 'section';

        let slug = base;
        let n = 2;

        while (used[slug]) {
            slug = base + '-' + n++;
        }

        used[slug] = true;

        return slug;
    }

    function initToc() {
        const body = document.querySelector('[data-toc-body]');
        const wrap = document.querySelector('[data-toc-wrap]');
        const nav = document.querySelector('[data-toc]');

        if (!body || !wrap || !nav) {
            return;
        }

        const heads = Array.prototype.slice.call(body.querySelectorAll('h2'));

        if (!heads.length) {
            return;
        }

        const used = {};
        const links = heads.map(function(h) {
            if (h.id) {
                used[h.id] = true;
            } else {
                h.id = slugify(h.textContent, used);
            }

            const a = document.createElement('a');

            a.href = '#' + h.id;
            a.textContent = h.textContent;
            a.className = 'post-toc__link';

            a.addEventListener('click', function(e) {
                e.preventDefault();

                const top = h.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;

                window.scrollTo({ top: top, behavior: 'smooth' });

                if (history.replaceState) {
                    history.replaceState(null, '', '#' + h.id);
                }
            });

            nav.appendChild(a);

            return a;
        });

        wrap.removeAttribute('hidden');

        // Scrollspy: mark the link whose section is nearest the top of the viewport.
        function spy() {
            const pos = window.pageYOffset + SPY_OFFSET;
            let current = 0;

            for (let i = 0; i < heads.length; i++) {
                if (heads[i].getBoundingClientRect().top + window.pageYOffset <= pos) {
                    current = i;
                }
            }

            links.forEach(function(l, i) {
                l.classList.toggle('is-active', i === current);
            });
        }

        spy();
        window.addEventListener('scroll', spy, { passive: true });
    }

    if (document.readyState !== 'loading') {
        initToc();
    } else {
        document.addEventListener('DOMContentLoaded', initToc);
    }
})();
